interface RenderPublicationHeroResponse {
  body: string;
}

interface CurrentOfferResponse {
  body: string;
}

export const getOfferContent = async (
  offerCtaTitleTranslationKey: string,
  offerCtaSubTitleTranslationKey: string
): Promise<CurrentOfferResponse> => {
  const response = await fetch('/api/full/get_offer_content?' + new URLSearchParams({
    offer_cta_title_translation_key: offerCtaTitleTranslationKey,
    offer_cta_sub_title_translation_key: offerCtaSubTitleTranslationKey
  }));

  if (response.ok) {
    const json = await response.json() as CurrentOfferResponse;
    return json;
  } else {
    throw new Error("Could not get current offer");
  }
}

export const getOfferDisplayContent = async (
  publicationId: string,
  issueId: string,
  publicationTitle: string,
  loggedInWithSubscriptionTranslationKey: string,
  offerTextUnderButtonTranslationKey: string,
): Promise<RenderPublicationHeroResponse> => {
  const response = await fetch('/api/full/get_dynamic_offer_content?' + new URLSearchParams({
    publication_id: publicationId,
    issue_id: issueId,
    publication_title: publicationTitle,
    logged_in_with_subscription_translation_key: loggedInWithSubscriptionTranslationKey,
    offer_text_under_button_translation_key: offerTextUnderButtonTranslationKey,
  }));

  if (response.ok) {
    const json = await response.json() as RenderPublicationHeroResponse;
    return json;
  } else {
    throw new Error("Could not offer display content");
  }
}
